import { createSlice } from "@reduxjs/toolkit";

export const AlertSlice = createSlice({
    name:"alertSlice",
    initialState:{
        alert_array:[],
        residents_with_alerts:[],
        latest_alert:{
            content:[],                 // [ {time:"", alert:"", alertContent:""},...]
            response:false,
            resident_id:"",
            resident:{},
            bed:{},
        }
    },
    reducers:{
        ADD_ALERTS_ARRAY:(state, action)=>{
            if(action.payload!==null){
                state.alert_array=action.payload
            }
        },
        ADD_ALERTS_ARRAY_RESIDENT:(state, action)=>{
            if(action.payload!==null){
                state.residents_with_alerts=action.payload
            }
        },
        ADD_ALERT:(state, action)=>{
            let _temp = {
                content:[],                 // [ {time:"", alert:"", alertContent:""},...]
                response:false,
                resident_id:"",
                resident:{},
                bed:{},
            }
            let _content = {
                time: "",
                alert: "",
                alert_type_id:"",
                alertContent: "",
            }
            if(action.payload!==null || action.payload!==undefined){
                let index = state.residents_with_alerts.indexOf(action.payload.resident_id)
                _content = {
                    time: action.payload.time,
                    alert:action.payload.type,
                    alertContent: action.payload.alertContent,
                    alert_type_id: action.payload.alert_type_id,
                }
                _temp.content.push(_content)
                _temp.response = action.payload.response
                _temp.resident_id = action.payload.resident_id
                _temp.resident = action.payload.resident
                _temp.bed = action.payload.bed_id

                if(index===-1){
                    state.residents_with_alerts.push(action.payload.resident_id)
                    state.alert_array.push(_temp)
                }else{
                    state.alert_array[index].content.push(_content)
                }
                
            }
        },
    },

})

export const {
    ADD_ALERTS_ARRAY,
    ADD_ALERT,
    ADD_ALERTS_ARRAY_RESIDENT
} = AlertSlice.actions

export default AlertSlice.reducer